(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["elookus-learning-guide"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elookus-learning-guide')) {
    customElements.define('elookus-learning-guide', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const button = this.querySelector('[data-learning-toggle]');
        const status = this.querySelector('[data-learning-status]');
        if (!button) return;
        const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        button.hidden = reducedMotion;
        const lightControls = this.querySelector('[data-learning-light-controls]');
        if (lightControls) {
          lightControls.hidden = false;
          lightControls.querySelectorAll('[data-learning-light]').forEach(control => {
            control.addEventListener('click', () => {
              this.dataset.playing = 'false';
              this.dataset.light = control.dataset.learningLight;
              button.setAttribute('aria-pressed', 'false');
              button.textContent = button.dataset.playLabel;
              status.textContent = button.dataset.pausedLabel;
              lightControls.querySelectorAll('[data-learning-light]').forEach(item => item.setAttribute('aria-pressed', String(item === control)));
            });
          });
        }
        button.addEventListener('click', () => {
          const playing = this.dataset.playing !== 'true';
          if (this.dataset.guide === 'lens' && playing) {
            this.dataset.light = 'demo';
            lightControls?.querySelectorAll('[data-learning-light]').forEach(item => item.setAttribute('aria-pressed', 'false'));
          }
          this.dataset.playing = String(playing);
          button.setAttribute('aria-pressed', String(playing));
          button.textContent = playing ? button.dataset.pauseLabel : button.dataset.playLabel;
          status.textContent = playing ? button.dataset.playingLabel : button.dataset.pausedLabel;
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["elookus-product-video"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('elookus-click-video')) {
    customElements.define('elookus-click-video', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.querySelector('.elookus-unboxing__play').addEventListener('click', (event) => this.activate(event), { once: true });
      }
      activate(initialEvent) {
        const poster = this.querySelector('img[data-video-src]');
        const video = document.createElement('video');
        video.id = poster.id;
        video.className = poster.className;
        video.width = 720;
        video.height = 1280;
        video.preload = 'none';
        video.controls = true;
        video.muted = true;
        video.playsInline = true;
        video.tabIndex = -1;
        video.poster = poster.src;
        video.dataset.videoSrc = poster.dataset.videoSrc;
        video.setAttribute('aria-label', poster.alt);
        poster.replaceWith(video);
        const button = this.querySelector('.elookus-unboxing__play');
        const fallback = this.querySelector('.elookus-unboxing__fallback');
        const status = this.querySelector('.elookus-unboxing__status');
        const panel = this.querySelector('.elookus-unboxing__controls');
        let simple = false;
        let dragging = false;
        let toggle;
        let sound;
        let seek;
        let time;
        let system;
        const format = (value) => {
          const seconds = Number.isFinite(value) ? Math.max(0, Math.floor(value)) : 0;
          return `${Math.floor(seconds / 60)}:${String(seconds % 60).padStart(2, '0')}`;
        };
        const setStatus = (message) => {
          if (status.textContent !== message) status.textContent = message;
        };
        const atEnd = () => video.ended || (Number.isFinite(video.duration) && video.duration > 0 && video.currentTime >= video.duration - 0.05);
        const sync = () => {
          if (!simple) return;
          const action = video.error ? 'Retry' : atEnd() ? 'Replay' : video.paused ? 'Play' : 'Pause';
          toggle.setAttribute('aria-label', action);
          toggle.title = action;
          toggle.dataset.state = action === 'Pause' ? 'playing' : 'paused';
          sound.dataset.muted = String(video.muted);
          sound.title = video.muted ? 'Sound off' : 'Sound on';
          sound.setAttribute('aria-pressed', String(video.muted));
          const duration = video.duration;
          const available = Number.isFinite(duration) && duration > 0;
          seek.disabled = !available;
          seek.max = available ? duration : 100;
          if (!dragging) seek.value = available ? video.currentTime : 0;
          const current = dragging ? Number(seek.value) : video.currentTime;
          seek.style.setProperty('--video-progress', `${available ? Math.min(100, Math.max(0, current / duration * 100)) : 0}%`);
          time.textContent = `${format(current)} / ${format(duration)}`;
          seek.setAttribute('aria-valuetext', `${format(current)} of ${format(duration)}`);
        };
        const restore = () => {
          const restoreFocus = this.contains(document.activeElement);
          button.hidden = false;
          fallback.hidden = false;
          this.setAttribute('data-video-error', '');
          if (system) system.hidden = false;
          setStatus(status.dataset.errorMessage);
          video.removeAttribute('aria-busy');
          sync();
          if (restoreFocus) (simple ? toggle : button).focus();
        };
        video.addEventListener('error', restore);
        video.addEventListener('playing', () => {
          button.hidden = true;
          fallback.hidden = true;
          this.removeAttribute('data-video-error');
          if (system) system.hidden = true;
          video.removeAttribute('aria-busy');
          setStatus('');
          sync();
        });
        const play = (event) => {
          setStatus('');
          fallback.hidden = true;
          this.removeAttribute('data-video-error');
          if (system) system.hidden = true;
          if (!video.dataset.videoSrc) { restore(); return; }
          if (!video.getAttribute('src') || video.error) {
            video.src = video.dataset.videoSrc;
            video.load();
          }
          button.hidden = true;
          video.tabIndex = simple ? -1 : 0;
          if (event.detail === 0) (simple ? toggle : video).focus();
          if (atEnd()) video.currentTime = 0;
          const playback = video.play();
          if (playback) playback.catch((error) => {
            if (error.name === 'AbortError' && video.paused && !video.error) { sync(); return; }
            restore();
          });
          sync();
        };
        button.addEventListener('click', play);
        if (this.hasAttribute('data-simple-controls') && panel) {
          try {
            toggle = panel.querySelector('[data-video-toggle]');
            sound = panel.querySelector('[data-video-sound]');
            seek = panel.querySelector('[data-video-seek]');
            time = panel.querySelector('[data-video-time]');
            system = panel.querySelector('[data-video-system]');
            if (!toggle || !sound || !seek || !time || !system) throw new Error('Missing controls');
            toggle.addEventListener('click', (event) => {
              if (!simple) return;
              if (video.paused || atEnd() || video.error) play(event);
              else video.pause();
            });
            sound.addEventListener('click', () => {
              if (!simple) return;
              video.muted = !video.muted;
              sync();
            });
            const finishSeek = () => {
              if (!simple || seek.disabled) return;
              video.currentTime = Number(seek.value);
              dragging = false;
              sync();
            };
            seek.addEventListener('input', () => {
              if (!simple) return;
              dragging = true;
              sync();
            });
            seek.addEventListener('change', finishSeek);
            seek.addEventListener('blur', () => { if (dragging) finishSeek(); });
            seek.addEventListener('pointercancel', () => { dragging = false; sync(); });
            system.addEventListener('click', (event) => {
              simple = false;
              video.controls = true;
              video.tabIndex = 0;
              panel.hidden = true;
              button.hidden = Boolean(video.getAttribute('src'));
              setStatus('System player controls enabled.');
              if (event.detail === 0) video.focus();
            });
            ['play', 'pause', 'ended', 'timeupdate', 'durationchange', 'loadedmetadata', 'volumechange'].forEach((name) => video.addEventListener(name, sync));
            video.addEventListener('pause', () => {
              if (!simple || video.error || atEnd()) return;
              video.removeAttribute('aria-busy');
              setStatus('Paused.');
            });
            ['waiting', 'stalled', 'seeking'].forEach((name) => video.addEventListener(name, () => {
              if (!simple) return;
              video.setAttribute('aria-busy', 'true');
              setStatus(name === 'seeking' ? 'Seeking...' : 'Loading video...');
            }));
            video.addEventListener('seeked', () => {
              video.removeAttribute('aria-busy');
              if (!video.error) setStatus('');
              sync();
            });
            video.addEventListener('ended', () => { if (simple) setStatus('Video ended. Select Replay to watch again.'); });
            simple = true;
            sync();
            panel.hidden = false;
            video.controls = false;
          } catch (error) {
            simple = false;
            video.controls = true;
            panel.hidden = true;
          }
        }
        play(initialEvent);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();

        const collapseEnabled = this.dataset.collapse === 'true';
        if (!collapseEnabled) return;

        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  // Look for an element with class 'related-products'
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null || productRecommendationsSection.dataset.browsingCategory) { return; }
  // Create request and submit it using Ajax
  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
    }
  };
  request.send();
};
// fetch when section reloads in editor
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});
// Fetching the recommendations on page load
loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
